/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropstatuslive2Inputs */

const en_dropstatuslive2 = /** @type {(inputs: Dropstatuslive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const de_dropstatuslive2 = /** @type {(inputs: Dropstatuslive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Dropstatuslive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropstatuslive2 = /** @type {((inputs?: Dropstatuslive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropstatuslive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropstatuslive2(inputs)
	return de_dropstatuslive2(inputs)
});
export { dropstatuslive2 as "dropStatusLive" }